import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-shared-button',
  templateUrl: './shared-button.component.html'
})
export class SharedButtonComponent implements OnInit {

  @Input() IsEmptyVal: boolean;
  @Output() private selectedTypeOfRedemption = new EventEmitter<string>();
  @Output() private searchingData = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  selectTypeOfRedemption(type) {
    this.selectedTypeOfRedemption.emit(type);
  }

  searchData(flag) {
    this.searchingData.emit(flag);
  }
}
